<template>
  <v-app>
     <v-main class="main">
      <Header
       v-if="setco"/>
      <router-view class="content-wrap"/>

    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      comune: null,
      setco: null
    }
  },
  computed: {
    ComuneStore () { return this.$store.getters.getComune }
  },
  watch: {
    $route: function (rot) {
      console.log('root -->', rot)
    },
    ComuneStore (newcs, oldcs) {
      console.log(oldcs, ' --> ', newcs)
      this.comune = newcs
      this.setco = this.comune.codiceCatasto
    }
  }

}
</script>
